import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatDivider } from '@angular/material/divider';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

import { ColorConstants } from '@celum/common-components/constants';
import { CelumIcon, IconConfiguration } from '@celum/common-components/icon';

import { CountStringPipe } from '../pipes/count-string.pipe';

@Component({
  selector: 'clm-notifications-header',
  imports: [MatDivider, MatSlideToggle, MatTooltipModule, TranslatePipe, CountStringPipe, CelumIcon],
  templateUrl: './notification-list-header.component.html',
  styleUrl: './notification-list-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationListHeaderComponent {
  public count = input<number>();
  public refreshCount = input<number>();

  public markAllAsRead = output<void>();
  public showOnlyUnread = output<boolean>();
  public refresh = output<void>();

  protected changeListMenuIcon = IconConfiguration.small(`refresh-s`).withColor(ColorConstants.SYSTEM_WHITE);
}
